
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/launchpad",
      function () {
        return require("private-next-pages/launchpad.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/launchpad"])
      });
    }
  